import React from "react";
import { PresentationIcon, FileTextIcon, GlobeIcon, SwordsIcon, FolderSearchIcon, ChartLineIcon, UserSearchIcon, ScaleIcon, RadarIcon, ChartColumnIcon, BoxIcon } from "lucide-react";
import { ToolIconName } from "../../types/tools";
import { cn } from "../../src/lib/utils";
const ICONS: Record<ToolIconName, BoxIcon> = {
  presentation: PresentationIcon,
  'file-text': FileTextIcon,
  globe: GlobeIcon,
  swords: SwordsIcon,
  'folder-search': FolderSearchIcon,
  'line-chart': ChartLineIcon,
  'user-search': UserSearchIcon,
  scale: ScaleIcon,
  radar: RadarIcon,
  'bar-chart': ChartColumnIcon
};
type ToolIconProps = {
  name: ToolIconName;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
};
const SIZES = {
  sm: {
    tile: 'h-9 w-9 rounded-lg',
    icon: 'h-4 w-4'
  },
  md: {
    tile: 'h-11 w-11 rounded-xl',
    icon: 'h-5 w-5'
  },
  lg: {
    tile: 'h-14 w-14 rounded-2xl',
    icon: 'h-6 w-6'
  }
};

/** Consistent indigo icon tile used for every tool. */
export function ToolIcon({
  name,
  size = 'md',
  className
}: ToolIconProps) {
  const Icon = ICONS[name];
  return <span aria-hidden="true" className={cn('inline-flex shrink-0 items-center justify-center border border-[#E3DFF4] bg-[#F5F3FC] text-lime', SIZES[size].tile, className)} data-id="element-1567" data-mp="x3pjhzmsq434">
      <Icon className={SIZES[size].icon} strokeWidth={1.75} data-id="element-1568" data-mp="1b0mkuv0jj3y9" />
    </span>;
}